/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react'
import ReactDOM from 'react-dom'
import {
  MenuComponent,
  MenuEventArgs,
  MenuItemModel,
} from '@syncfusion/ej2-react-navigations'
import { ICalls } from '@dataTypes/calls.type'

interface FloatingMenuProps {
  anchorRect: DOMRect
  menuItems: MenuItemModel[]
  onSelect: (args: MenuEventArgs, selectedCall: ICalls) => void
  onClose: () => void
  selectedCall: ICalls
}

const FloatingMenu: React.FC<FloatingMenuProps> = ({
  anchorRect,
  menuItems,
  onSelect,
  onClose,
  selectedCall,
}) => {
  const MENU_WIDTH = useMemo(() => 182 - 26, [])
  const MENU_HEIGHT = useMemo(() => 220, [])
  const [position, setPosition] = useState<{ top: number; left: number }>({
    top: 0,
    left: 0,
  })

  useEffect(() => {
    const viewportHeight = window.innerHeight
    const shouldFlip = anchorRect.bottom + MENU_HEIGHT > viewportHeight

    const top = shouldFlip
      ? anchorRect.top + window.scrollY - MENU_HEIGHT // flip upward
      : anchorRect.bottom + window.scrollY // default (below)

    const left = anchorRect.right + window.scrollX - MENU_WIDTH

    setPosition({ top, left })

    const handleClickOutside = (e: MouseEvent): void => {
      if (!(e.target as HTMLElement).closest('.e-menu-wrapper')) {
        onClose()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [anchorRect, onClose])

  return ReactDOM.createPortal(
    <div
      style={{
        position: 'absolute',
        top: position.top,
        left: position.left,
        zIndex: 10000,
      }}
    >
      <MenuComponent
        items={menuItems}
        orientation="Vertical"
        select={(args: MenuEventArgs) => {
          onSelect(args, selectedCall)
        }}
        cssClass="mc-calls-more-options"
        showItemOnClick={false}
      />
    </div>,
    document.body,
  )
}

export default FloatingMenu
